module.exports = __webpack_public_path__ + "media/images/pageTitle__background-dd0a4e4ac6f4e0e9516df9d742c149ee.png";